var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { textBlack } from '../../../styles/variables/colors';
import { Header1TextStyles } from '../../../styles/variables/text.styles';
import BackButton from '../button/back.button';
import LangMessage from '../lang/message';
var PageLayoutStyles = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  min-height: calc(100vh - 74px - 40px);\n  background: white;\n  padding-top: 74px;\n  ", "\n  ", "\n"], ["\n  min-height: calc(100vh - 74px - 40px);\n  background: white;\n  padding-top: 74px;\n  ", "\n  ", "\n"])), function (_a) {
    var $isVisibleMenu = _a.$isVisibleMenu;
    return $isVisibleMenu && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      width: calc(100% - 70px);\n      padding-left: 70px;\n    "], ["\n      width: calc(100% - 70px);\n      padding-left: 70px;\n    "])));
}, function (_a) {
    var $isVisibleMenu = _a.$isVisibleMenu;
    return !$isVisibleMenu && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      width: calc(100% - 258px);\n      padding-left: 258px;\n    "], ["\n      width: calc(100% - 258px);\n      padding-left: 258px;\n    "])));
});
var PageLayoutHeader = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding-top: 80px;\n"], ["\n  display: flex;\n  align-items: center;\n  padding-top: 80px;\n"])));
export var PageTitle = styled.h1(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  padding-left: 20px;\n"], ["\n  ", ";\n  color: ", ";\n  padding-left: 20px;\n"])), Header1TextStyles, textBlack);
var PageChilgren = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  max-width : 1440px;\n  margin: 0px auto 0px;\n  padding: 40px;\n"], ["\n  max-width : 1440px;\n  margin: 0px auto 0px;\n  padding: 40px;\n"])));
export var PageLayout = function (_a) {
    var title = _a.title, onClickBackButton = _a.onClickBackButton, children = _a.children;
    var _b = useState(false), isVisibleMenu = _b[0], setIsVisibleMenu = _b[1];
    useEffect(function () {
        var savedValue = localStorage.getItem('isVisibleMenu');
        setIsVisibleMenu(savedValue ? JSON.parse(savedValue) : false);
        var handleStorage = function () {
            var savedValue = localStorage.getItem('isVisibleMenu');
            setIsVisibleMenu(savedValue ? JSON.parse(savedValue) : false);
        };
        window.addEventListener('storage', handleStorage);
        return function () { return window.removeEventListener('storage', handleStorage); };
    }, []);
    return (_jsxs(PageLayoutStyles, __assign({ "$isVisibleMenu": isVisibleMenu }, { children: [title &&
                _jsxs(PageLayoutHeader, { children: [_jsx(BackButton, { onClick: onClickBackButton }), _jsx(PageTitle, { children: _jsx(LangMessage, { msgKey: title, defaultValue: 'GAD art' }) })] }), _jsx(PageChilgren, { children: children })] })));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
